export const newsArticlesLoaded = (payload) => ({
  type: 'NEWS_ARTICLES_LOADED', payload
});

export const newsLoadingFinished = () => ({
  type: 'NEWS_LOADING_FINISHED'
});

export const newsLoadingStarted = () => ({
  type: 'NEWS_LOADING_STARTED'
});

export const newsArticleAdded = (payload) => ({
  type: 'NEWS_ARTICLE_ADDED', payload
});
